import { useRutilusQuery } from '../../../../../../../api/graphql/useRutilusQuery';
import { notEmpty } from '../../../../../../../helpers/array';
import { getNodesFromConnection } from '../../../../../../../helpers/graphql';
import { getDomain, getPostUrl } from '../../../../../../../helpers/urls';
import { GetPostLikes, GetPostLikesVariables } from '../../../../../../../interfaces/graphql';
import type { Post } from '../../../../../types/Post';
import { Video } from '../../../../../types/Video';
import type { Image } from '../../../../../types/Image';
import { IDisplayEntity, IGQLPostProductUnitNode } from '../../../../../../../interfaces/post';
import { getPostLikes } from '../../../../../../../queries/rutilus/Posts';

interface PostItemData {
  commentsCount: number;
  content: string;
  displayEntity?: IDisplayEntity | null;
  images: Image[];
  video: Video | null;
  isPostLiked: boolean;
  postId: string;
  postLikesCount: number;
  postUrl: string;
  statementDate: Date;
  usedGearsCount: number;
  userAvatarUrl: string;
  userDetails: string[];
  userId: string;
  userNickName: string;
  usedGearFromPost?: IGQLPostProductUnitNode[];
  hasCatch?: boolean;
}

export const usePostItem = (post: Post): PostItemData => {
  const {
    _id: postId,
    catch: catchData,
    comments,
    createdAt,
    displayProductUnits,
    displayEntity,
    productUnits,
  } = post;
  const { images: imagesData, video, likedByCurrentUser, likesCount, text, user } = post;
  const { _id: userId, avatar, nickname } = user;
  const { data } = useRutilusQuery<GetPostLikes, GetPostLikesVariables>(getPostLikes, {
    variables: { externalId: postId },
    skip: !postId,
  });
  const hasCatch = !!catchData;
  const commentsCount = comments.totalCount;
  const content = text.text ?? '';
  const userNickName = nickname;
  const images = getNodesFromConnection(imagesData);
  const isPostLiked = data?.post.likedByCurrentUser ?? likedByCurrentUser;
  const postLikesCount = data?.post.likesCount ?? likesCount;
  const postUrl = `${getDomain()}${getPostUrl(postId)}`;
  const statementDate = new Date(createdAt);
  const usedGearsCount = displayProductUnits.totalCount;
  const userAvatarUrl = avatar?.url ?? '';
  const fishingWater = catchData?.fishingWater?.displayName;
  const species = catchData?.species?.displayName;
  const userDetails = [fishingWater, species].filter(notEmpty);
  const usedGearFromPost = getNodesFromConnection<IGQLPostProductUnitNode>(productUnits);

  return {
    commentsCount,
    content,
    displayEntity,
    images,
    video,
    isPostLiked,
    postId,
    postLikesCount,
    postUrl,
    statementDate,
    usedGearsCount,
    userAvatarUrl,
    userDetails,
    userId,
    userNickName,
    usedGearFromPost,
    hasCatch,
  };
};
